import { PluginSpecification } from '@valtimo/plugin';
import { GriffieConfigurationComponent } from './components/griffie-configuration/griffie-configuration.component';
import { TEZZA_PLUGIN_LOGO_BASE64 } from './assets/tezza-plugin-logo';

const griffiePluginSpecification: PluginSpecification = {
  pluginId: 'griffieplugin',
  pluginConfigurationComponent: GriffieConfigurationComponent,
  pluginLogoBase64: TEZZA_PLUGIN_LOGO_BASE64,
  pluginTranslations: {
    nl: {
      title: 'Griffie Proces',
      description:
        'De Griffie-plugin beheerd de configuratie voor het Griffie proces',
      configurationTitle: 'Configuratienaam',
      configurationTitleTooltip:
        'De naam van de huidige plugin-configuratie. Onder deze naam kan de configuratie in de rest van de applicatie teruggevonden worden.',
      bronorganisatieName: 'Bronorganisatie naam',
      bronorganisatieNameTooltip: 'Dit veld moet de naam van de bronorganisatie bevatten.',
      bronorganisatie: 'Bronorganisatie (RSIN)',
      bronorganisatieTooltip: 'Dit veld moet het RSIN nummer van de bronorganisatie bevatten.',
      groupMail: 'Groep mailbox',
      groupMailTooltip: 'Het mailadres van de groepsmail voor de bronorganisatie.',
      candidateGroup: 'Candidate Group',
      candidateGroupTooltip: 'De rol in Keycloak die bij deze bronorganisatie hoort.',
      organizations: 'Bronorganisaties',
      organizationsTooltip: 'Bronorganisaties binnen het Griffie proces',
      addGriffieType: 'Bronorganisatie toevoegen',
    },
    en: {
      title: 'Griffie Process',
      description:
        'The Griffie plugin manages the configuration for the Griffie process',
      configurationTitle: 'Configuration name',
      configurationTitleTooltip:
        'The name of the current plugin configuration. Under this name, the configuration can be found throughout the rest of the application.',
      bronorganisatieName: 'Source organization name',
      bronorganisatieNameTooltip: 'This field must contain the name of the source organization.',
      bronorganisatie: 'Source organization (RSIN)',
      bronorganisatieTooltip: 'This field must contain the RSIN number of the source organization.',
      groupMail: 'Group mailbox',
      groupMailTooltip: 'The email address of the group mailbox for the source organization.',
      candidateGroup: 'Candidate group',
      candidateGroupTooltip: 'The Keycloak role associated with this source organization.',
      organizations: 'Source organizations',
      organizationsTooltip: 'Source organizations within the Griffie process',
      addGriffieType: 'Add source organization',
    },
    de: {
      title: 'Griffie-Prozess',
      description:
        'Das Griffie-Plugin verwaltet die Konfiguration für den Griffie-Prozess',
      configurationTitle: 'Konfigurationsname',
      configurationTitleTooltip:
        'Der Name der aktuellen Plugin-Konfiguration. Unter diesem Namen kann die Konfiguration im restlichen Teil der Anwendung wiedergefunden werden.',
      bronorganisatieName: 'Name der Quellorganisation',
      bronorganisatieNameTooltip: 'Dieses Feld muss den Namen der Quellorganisation enthalten.',
      bronorganisatie: 'Quellorganisation (RSIN)',
      bronorganisatieTooltip: 'Dieses Feld muss die RSIN-Nummer der Quellorganisation enthalten.',
      groupMail: 'Gruppenpostfach',
      groupMailTooltip: 'Die E-Mail-Adresse des Gruppenpostfachs der Quellorganisation.',
      candidateGroup: 'Kandidatengruppe',
      candidateGroupTooltip: 'Die Keycloak-Rolle, die dieser Quellorganisation zugeordnet ist.',
      organizations: 'Quellorganisationen',
      organizationsTooltip: 'Quellorganisationen innerhalb des Griffie-Prozesses',
      addGriffieType: 'Quellorganisation hinzufügen',
    },
  },
};

export { griffiePluginSpecification };
